import React from 'react';
import SVG from 'react-svg';
export default () => React.createElement(SVG, { path: "https://static.ux.cimpress.io/assets/images/page_error_404.svg" });
